import { OutlinedTextFieldProps } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { parse } from "date-fns";
import dayjs from "dayjs";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Field, getIn, useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import _ from "lodash";
import React from "react";
import { OLDate } from "utilities/dateFormat";
import { inputStyles } from "./styles";

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      maxWidth: "100%",
      width: ({ fullWidth }: { fullWidth?: boolean }) =>
        fullWidth ? "100%" : 373,
      ...inputStyles,
    },
  }),
);
type Props = Omit<OutlinedTextFieldProps, "variant">;
interface TimeInputProps extends Props {
  displayFormat?: string;
  format?: string;
  name: string;
  "data-test-id"?: string;
}
export function TimeInput(props: TimeInputProps) {
  const classes = useStyles(props);
  const { message } = useMessage();
  const { setFieldValue, values } = useFormikContext<any>();
  const { displayFormat, ...passedProps } = props;
  const [innerDate, setDate] = React.useState(
    _.get(values, props.name)
      ? parse(_.get(values, props.name), "HH:mm", new Date())
      : "",
  );

  return (
    <Field name={props.name}>
      {({ field, form, meta }: { field: any; form: any; meta: any }) => (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          localeText={{ okButtonLabel: message({ id: "save" }) }}
        >
          <TimePicker
            {...field}
            {...passedProps}
            closeOnSelect={false}
            value={field.value ? dayjs(innerDate) : null}
            slotProps={{
              openPickerIcon: {
                "data-test-id": `${props["data-test-id"]}-icon`,
              },
              toolbar: {
                toolbarTitle: props.label,
              },
              actionBar: {
                actions: ["cancel", "accept"],
              },
              textField: {
                error: !!(
                  meta.error ||
                  props.error ||
                  getIn(form.status, field.name)
                ),
                helperText:
                  meta.error ||
                  (_.isArray(getIn(form.status, field.name))
                    ? getIn(form.status, field.name)
                    : props.helperText) ||
                  "",
                "data-test-id": props["data-test-id"],
              },
            }}
            className={`${classes.input} ${props.className}`}
            inputVariant="outlined"
            format="hh:mm a"
            sx={{
              "& .MuiPickersToolbar-penIconButton": { display: "none" },
            }}
            onChange={(date: any) => {
              if (props.name && date) {
                setDate(date);
                setFieldValue(
                  props.name,
                  OLDate(date, { formatString: props.format || "HH:mm" }),
                );
              }
            }}
          />
        </LocalizationProvider>
      )}
    </Field>
  );
}
